<template lang="pug">
  CommonMiddleHeader(
    inactive-color='white'
    :left-black-when-inactive="false"
    :leftBlackWhenActive="false"
    backgroundColor="1,106,255"
  )
    template(slot='left')
      .fuli-header-version
        img.page-logo(src="https://m.hellobike.com/resource/gallery/833/391Tn9H9_Group%201707483340%20(1).png")
        .page-noema(v-if="!pureVersion") 单单返币 0元兑好物
    template(slot='right')
      .dot-icon-btn-area
        DotBtn
    template(slot='left-noscroll')
      .fuli-herder-new-over(@click="goBountyRecord")
        img.icon(
          src="https://m.hellobike.com/resource/gallery/833/W5VUYJ1L_16x16%EF%BC%883x%EF%BC%89%20(1).png"
        )
        .amount {{ points }}
        img.go(src="https://m.hellobike.com/resource/gallery/61/kH9lAb93-Z.png?x-oss-process=image/quality,q_80")
</template>

<script>
import CommonMiddleHeader from '@/components/common-middle-header';
import DotBtn from './dot-btn';

export default {
  name: 'WelfareNavbar',
  components: {
    CommonMiddleHeader,
    DotBtn,
  },
  props: {
    points: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  inject: ['isPureVersion'],
  computed: {
    // 是否是纯净版页面
    pureVersion() {
      return this.isPureVersion();
    },
  },
  mounted() {},
  methods: {
    // 点击积分
    goBountyRecord() {
      this.$emit('pointsClick');
    },
  },
};
</script>

<style lang="less" scoped>
.fuli-header-version {
  display: flex;
  align-items: center;
  height: 0.18rem;

  .page-logo {
    width: 0.92rem;
    height: 0.3rem;
    vertical-align: bottom;
    transform: translateY(0.03rem);
  }

  .page-noema {
    position: relative;
    padding: 0 0 0 0.1rem;
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.14rem;
    line-height: 0.18rem;
    transform: translateY(0.04rem);

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0.05rem;
      transform: translateY(-50%);
      width: 0.01rem;
      height: 0.1rem;
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
}

.dot-icon-btn-area {
  position: absolute;
  bottom: 0.12rem;
  right: 0.15rem;
}

.fuli-herder-new-over {
  min-width: 0.62rem;
  height: 0.24rem;
  border-radius: 0.12rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.04rem 0.03rem 0.03rem 0.08rem;

  img.icon {
    transform: translateY(-0.01rem);
    width: 0.16rem;
    height: 0.16rem;
    margin-right: 0.02rem;
  }

  .amount {
    font-family: 'DIN Alternate Bold', sans-serif;
    font-weight: 500;
    font-size: 0.16rem;
    line-height: normal;
    text-align: center;
  }

  img.go {
    margin-left: 0.01rem;
    width: 0.14rem;
    height: 0.14rem;
  }
}
</style>
